import { render, staticRenderFns } from "./ordenar_categorias.vue?vue&type=template&id=44d5044b&"
import script from "./ordenar_categorias.vue?vue&type=script&lang=js&"
export * from "./ordenar_categorias.vue?vue&type=script&lang=js&"
import style0 from "./ordenar_categorias.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports